import Box from "@mui/material/Box";
import { useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";

import { getDossier } from "../../api/dossier/getDossier";
import { getFaq } from "../../api/faq/getFaq";
import { getQuote } from "../../api/quote/getQuote";
import APContactHelpButton from "../../components/buttons/APContactHelpButton";
import ModalContainer from "../../components/ModalContainer";
import RestrictedAppScope from "../../components/RestrictedAppScope";
import { formatQuote } from "../../helpers/format";
import { useApi } from "../../providers/ApiProvider";
import { useAuth } from "../../providers/AuthProvider";
import FaqDetails from "../components/FaqDetails";

const ViewFaq = () => {
  const { faqId } = useParams();
  const { fetchWithAuth } = useApi();
  const { inAppScope } = useAuth();
  const [searchParams] = useSearchParams();

  const quoteId = searchParams.get("modal.quoteId") ?? null;
  const opportunityId = searchParams.get("modal.opportunityId") ?? null;
  const dossierId = searchParams.get("modal.dossierId") ?? null;
  const appLocationId = searchParams.get("modal.appLocationId") ?? null;
  const faqAppLocationId = searchParams.get("modal.faqAppLocationId") ?? null;

  if (!faqId) {
    // TODO: improve client side error messaging
    throw new Error("faq id param is misisng");
  }

  const faq = getFaq(faqId);

  const quote = getQuote(quoteId ?? "", {
    useCached: true,
    disabled: !quoteId,
  });

  const dossier = getDossier(dossierId ?? "", {
    useCached: true,
    disabled: !dossierId,
  });

  if (faq && faq.isError) {
    throw faq.error;
  }

  if (quote.isError) {
    throw quote.error;
  }

  if (dossier.isError) {
    throw dossier.error;
  }

  const trackView = (faqId: string) => {
    if (faq.isSuccess && inAppScope("external")) {
      fetchWithAuth<void>("createFaqView", faqId, {
        requestOptions: {
          method: "post",
          body: JSON.stringify({
            appLocationId: appLocationId,
            faqAppLocationId,
          }),
        },
      });
    }
  };

  useEffect(() => {
    if (faq.isSuccess) {
      trackView(faq.data.id);
    }
  }, [faq.data?.id]);

  const isLoading = faq.isLoading || quote.isLoading || dossier.isLoading;
  const isSuccess =
    faq.isSuccess &&
    (!quoteId || quote.isSuccess) &&
    (!dossierId || dossier.isSuccess);

  return (
    <ModalContainer loading={isLoading}>
      {isSuccess && (
        <Box>
          {faq.data && (
            <FaqDetails
              faq={faq.data}
              quote={quote.data ? formatQuote(quote.data) : undefined}
              dossier={dossier.isSuccess ? dossier.data : undefined}
              appLocationId={appLocationId}
            />
          )}
          <RestrictedAppScope scope="external">
            <Box mt={2} sx={{ display: "flex", justifyContent: "start" }}>
              <APContactHelpButton
                regardingOpportunityId={opportunityId ?? undefined}
              />
            </Box>
          </RestrictedAppScope>
        </Box>
      )}
    </ModalContainer>
  );
};

export default ViewFaq;
